var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLighthouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37409 5.084L11.7227 2.18493C11.8906 2.07296 12.1094 2.07296 12.2774 2.18493L16.626 5.084C17.0376 5.35841 16.8433 6.00003 16.3486 6.00003H16V9.25C16.4142 9.25 16.75 9.58579 16.75 10C16.75 10.3684 16.4844 10.6748 16.1342 10.738L16.3847 12.116L7.38147 13.4022L7.86586 10.738C7.51568 10.6748 7.25005 10.3684 7.25005 10C7.25005 9.58579 7.58584 9.25 8.00005 9.25V6.00003H7.65144C7.15673 6.00003 6.96247 5.35841 7.37409 5.084ZM11 9.25H13V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V9.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6532 13.5929L7.0986 14.9578L6.63477 17.5089L17.0936 16.0147L16.6532 13.5929Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35191 19.0645L17.3621 17.4916L17.8182 20H18C18.5523 20 19 20.4477 19 21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21C5 20.4477 5.44772 20 6 20H6.18182L6.35191 19.0645Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6431 3.61412C21.8562 3.9693 21.7411 4.43 21.3859 4.64311L18.8859 6.14311C18.5307 6.35622 18.07 6.24105 17.8569 5.88586C17.6438 5.53068 17.7589 5.06998 18.1141 4.85687L20.6141 3.35687C20.9693 3.14376 21.43 3.25893 21.6431 3.61412Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 8C17.75 7.58579 18.0858 7.25 18.5 7.25H22C22.4142 7.25 22.75 7.58579 22.75 8C22.75 8.41421 22.4142 8.75 22 8.75H18.5C18.0858 8.75 17.75 8.41421 17.75 8Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8569 10.1141C18.07 9.75893 18.5307 9.64376 18.8859 9.85687L21.3859 11.3569C21.7411 11.57 21.8562 12.0307 21.6431 12.3859C21.43 12.7411 20.9693 12.8562 20.6141 12.6431L18.1141 11.1431C17.7589 10.93 17.6438 10.4693 17.8569 10.1141Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61412 4.64311C2.25893 4.43 2.14376 3.9693 2.35687 3.61412C2.56998 3.25893 3.03068 3.14376 3.38586 3.35687L5.88586 4.85687C6.24105 5.06998 6.35622 5.53068 6.14311 5.88586C5.93 6.24105 5.4693 6.35622 5.11412 6.14311L2.61412 4.64311Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.25C5.91421 7.25 6.25 7.58579 6.25 8C6.25 8.41421 5.91421 8.75 5.5 8.75H2C1.58579 8.75 1.25 8.41421 1.25 8C1.25 7.58579 1.58579 7.25 2 7.25H5.5Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11412 9.85687C5.4693 9.64376 5.93 9.75893 6.14311 10.1141C6.35622 10.4693 6.24105 10.93 5.88586 11.1431L3.38586 12.6431C3.03068 12.8562 2.56998 12.7411 2.35687 12.3859C2.14376 12.0307 2.25893 11.57 2.61412 11.3569L5.11412 9.85687Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLighthouse);
export default __webpack_public_path__ + "static/media/lighthouse.805ed6ce13fd6eaa41c965333ce23479.svg";
export { ForwardRef as ReactComponent };